import { showAlert } from 'actions/client';
import { createVenue, fetchManagedPages } from 'actions/venue';
import ComboInputField from 'components/FormElements/ComboInputField';
import FormAuthTextField from 'components/FormElements/FormAuthTextField';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import LinkToPageTooltip from 'components/Utility/TooltipModal/LinkToPageTooltip';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Required } from 'utils/validators';
import './index.scss';

class CreateVenueForm extends Component {
  componentWillMount() {
    this.props.handleSubmit(() => ({}));
    this.fetchFatsomaManagedPages();
  }

  componentWillUpdate(nextProps, nextState) {
    if (!nextProps.creatingVenue && this.props.creatingVenue) {
      if (!nextProps.venueCreated) {
        this.showVenueCreatedError();
      }
    }
  }

  submitCreateVenueForm = () => {
    this.props.createVenue(this.props.formValues);
  };

  onEnter = event => {
    if (event.key === 'Enter') {
      this.submitCreateVenueForm();
    }
  };

  fetchFatsomaManagedPages(data = {}) {
    if (!this.props.fatsomaPageConnected) {
      this.props.fetchManagedPages(data);
    }
  }

  queryFatsomaManagedPages(query) {
    if (!query || query.length < 2) {
      return;
    }

    if (this.props.managedPagesQueryable) {
      this.fetchFatsomaManagedPages({ query });
    }
  }

  showVenueCreatedError = () => {
    this.props.showAlert(
      'Something went wrong',
      'We could not create the venue. Please contact support.'
    );
  };

  render() {
    return (
      <React.Fragment>
        <h3>Add your venue</h3>
        <p className="venue__description">
          To get your venue setup on Tabb, first you need to give it a name. You
          can change this later if you want.
        </p>

        <form className="auth__form__fields" onKeyDown={this.onEnter}>
          <input type="hidden" value="prayer" />
          <Field
            className="auth__form__field"
            fullWidth
            name="name"
            type="text"
            margin="normal"
            placeholder="My Venue"
            component={FormAuthTextField}
            validate={[Required]}
            label="Venue Name"
          />

          <Field
            name="fatsoma_page_id"
            label="Link with Fatsoma Page"
            labelEndAdornment={<LinkToPageTooltip />}
            fullWidth
            component={ComboInputField}
            items={this.props.managedPages}
            isInputDisabled={
              this.props.managedPages.length < 1 &&
              !this.props.managedPagesQueryable
            }
            isItemDisabled={i => i.linked_to_venue}
            isLoading={this.props.fetchingManagedPages}
            noItemsMessage="No Available Pages"
            onInputEdit={v => this.queryFatsomaManagedPages(v)}
          />

          <FormSubmitButton
            onClick={this.submitCreateVenueForm}
            className="auth__cta__button"
            loading={this.props.creatingVenue}
          >
            Complete Setup
          </FormSubmitButton>
        </form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues('auth-create-venue')(state) || {},
    loading: state.authentication.loading,
    creatingVenue: state.venue.creatingVenue,
    fetchingManagedPages: state.venue.fetchingManagedPages,
    managedPages: state.venue.managedPages,
    managedPagesQueryable: state.venue.managedPagesQueryable,
    venueCreated: state.venue.venueCreated,
  };
};

const mapDispatchToProps = dispatch => ({
  createVenue: data => dispatch(createVenue(data)),
  fetchManagedPages: data => dispatch(fetchManagedPages(data)),
  showAlert: (title, message) => dispatch(showAlert(title, message)),
});

CreateVenueForm = reduxForm({
  form: 'auth-create-venue',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(CreateVenueForm);

export default connect(mapStateToProps, mapDispatchToProps)(CreateVenueForm);



// WEBPACK FOOTER //
// ./src/components/Authentication/CreateVenueForm/index.jsx